document.addEventListener("DOMContentLoaded", function () {
  var mainCarouselElement = new Splide("#main-carousel", {
    type: "fade",
    rewind: true,
    pagination: false,
    arrows: true,
  });

  var thumbnailsCarouselElement = new Splide("#thumbnail-carousel", {
    fixedWidth: 120,
    fixedHeight: 120,
    gap: 16,
    rewind: true,
    pagination: false,
    isNavigation: true,
    breakpoints: {
      600: {
        fixedWidth: 60,
        fixedHeight: 60,
        gap: 10,
        arrows: false,
      },
    },
  });

  mainCarouselElement.sync(thumbnailsCarouselElement);
  mainCarouselElement.mount();
  thumbnailsCarouselElement.mount();

  const tabTitles = document.querySelectorAll(".tab-question");

  tabTitles.forEach((title) => {
    const content = title.nextElementSibling;
    content.style.height = "0";
    content.style.overflow = "hidden";
    content.style.transition = "height 0.3s ease";

    title.addEventListener("click", function () {
      tabTitles.forEach((otherTitle) => {
        if (otherTitle !== this) {
          otherTitle.classList.remove("open");
          const otherContent = otherTitle.nextElementSibling;
          otherContent.style.height = "0";
        }
      });

      this.classList.toggle("open");
      const btn = this.querySelector(".tab-btn");
      const isOpen = this.classList.contains("open");

      if (isOpen) {
        content.style.height = content.scrollHeight + "px";
      } else {
        content.style.height = "0";
      }
    });
  });

  const deliveryDateSpans = document.querySelectorAll('[id^="delivery-date-"]');

  deliveryDateSpans.forEach(function (el) {
    const daysToAdd = parseInt(el.getAttribute("data-days"), 10) || 0;
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + daysToAdd);

    const options = {
      weekday: "short", // e.g., 'Sun'
      month: "short", // e.g., 'Jul'
      day: "numeric", // e.g., 27
    };

    const formattedDate = currentDate.toLocaleDateString("en-US", options);

    el.textContent = formattedDate; // Example: "Sun, Jul 27"
  });
});
